import { createSelector } from 'reselect'

const isLogged = state => state.auth.isLogged
const getUser = state => state.auth.user
const getSettings = state => state.auth.settings

export const getIsLogged = createSelector(
  [ isLogged ],
  isLogged => isLogged
)

export const getLoggedUser = createSelector(
  [ getUser ],
  user => user || false
)
export const getUserID = createSelector(
  [ getUser ],
  user => user._id || false
)

export const getSettingsInfo = createSelector(
  [ getUser, getSettings ],
  (user, settings) => {
    if (!user || !settings) return null

    let info = settings.logins
      .filter(el => [ 'email', 'phone' ].indexOf(el.type) !== -1)
      .reduce((obj, item) => {
        obj[item.type] = item.login
        return obj
      }, {})
    info.name = settings.settings.name
    info.surname = settings.settings.surname
    info.birthday = settings.settings.birthday
    info.birthmonth = settings.settings.birthmonth
    info.email = settings.settings.emails[settings.settings.emails.length - 1]
    info.dontShowEmailPopup = settings.settings.dontShowEmailPopup
    info.notifyEmail = settings.settings.notifyEmail
    info.notifyPhone = settings.settings.notifyPhone
    info.notifySMS = settings.settings.notifySMS
    info.notifyTelegram = settings.settings.notifyTelegram
    info.notifyWhatsapp = settings.settings.notifyWhatsapp
    info.notifyFacebook = settings.settings.notifyFacebook
    info.telegram = settings.settings.telegram
    info.telegramName = settings.settings.telegramName
    info.facebook = settings.settings.facebook

    return info
  }
)



// WEBPACK FOOTER //
// ./src/selectors/user.js